'use client';
import { StorageKeys } from '@constants/storageKeys';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export function RouteTracker() {
  const pathname = usePathname();

  useEffect(() => {
    const currentPath = sessionStorage.getItem(StorageKeys.CurrentPath);
    if (currentPath !== pathname) {
      sessionStorage.setItem(StorageKeys.PreviousPath, currentPath || '');
      sessionStorage.setItem(StorageKeys.CurrentPath, pathname);
    }
  }, [pathname]);

  return null;
}